// components/Hero.js
import React, { useState, useEffect } from 'react';
import './Hero.css';
import cert1 from '../asste/images/home/bj.jpg';
import cert2 from '../asste/images/home/bj1.png';
import cert4 from '../asste/images/home/bj3.jpg';

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);

  
  // 轮播背景图片数组
  const heroImages = [cert1, cert2,cert4];

  // 自动轮播
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000); // 每5秒切换一张图片
    
    return () => clearInterval(timer);
  }, [heroImages.length]);

  return (
    <section className="hero">
      {/* 背景图片轮播容器 */}
      <div className="hero-background">
        {heroImages.map((image, index) => (
          <div 
            key={index}
            className={`hero-slide ${currentImage === index ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image})` }}
            aria-hidden={currentImage !== index}
          />
        ))}
      </div>
      
      {/* 背景遮罩 */}
      <div className="hero-overlay"></div>
      
      {/* 主要内容 */}
      <div className="hero-content">
        <h1>天津勃昂环保科技有限公司</h1>
        <p className="hero-subtitle">
          专业环保技术服务提供商，致力于为客户提供高效、可靠的环保解决方案
        </p>
        <div className="hero-cta">
          <a href="#services" className="btn btn-primary">了解我们的服务</a>
          <a href="#contact" className="btn btn-secondary">联系我们</a>
        </div>
      </div>
      
      {/* 轮播指示器 */}
      <div className="hero-indicators">
        {heroImages.map((_, index) => (
          <button
            key={index}
            className={`indicator ${currentImage === index ? 'active' : ''}`}
            onClick={() => setCurrentImage(index)}
            aria-label={`切换到第 ${index + 1} 张背景图`}
          ></button>
        ))}
      </div>
    </section>
  );
};

export default Hero;